import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthLayout } from "@/layouts/AuthLayout";
import { VerifiedBadge } from "@/components/ui/VerifiedBadge";
import { api } from "@/lib/api";

type Status = "loading" | "ok" | "error";

export function VerifyPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [status, setStatus] = useState<Status>("loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setMsg("Lien invalide (token manquant)."); return; }
    void api("/api/account/email/verify/confirm", {
      method: "POST",
      body: JSON.stringify({ token }),
    })
      .then(() => { setStatus("ok"); setMsg("Email confirmé — badge « vérifier » débloqué."); })
      .catch((e: Error) => { setStatus("error"); setMsg(e.message || "Confirmation échouée"); });
  }, [token]);

  return (
    <AuthLayout>
      <h1 style={{ marginTop: 0 }}>Vérification email</h1>
      <div style={{ padding: 16, textAlign: "center", minHeight: 100 }}>
        {status === "loading" && <div className="muted">Vérification en cours…</div>}
        {status === "ok" && (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
            <VerifiedBadge size="md" />
            <div style={{ color: "#4ade80" }}>{msg}</div>
            <Link to="/" className="btn primary">Retour à sonslow</Link>
          </div>
        )}
        {status === "error" && (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
            <div style={{ color: "#f87171" }}>{msg}</div>
            <Link to="/" className="btn">Retour</Link>
          </div>
        )}
      </div>
    </AuthLayout>
  );
}
